import { render } from "./RetailerFooter.vue?vue&type=template&id=3ba47b28"
import script from "./RetailerFooter.vue?vue&type=script&lang=js"
export * from "./RetailerFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__